import React, { useState } from 'react';
import './NuevoClienteModal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserLock, faBoxOpen, faShareNodes, faRocket } from '@fortawesome/free-solid-svg-icons';
import { useData } from '../DataContext';
import { getTenantSlug, ruta } from '../paths';
import storage from '../storage';
import { useNavigate } from 'react-router-dom';

const pasos = [
    {
        icon: faUserLock,
        titulo: 'Inicia sesión',
        texto: 'Ingresá al panel de administración con tu cuenta para configurar tu catálogo.',
    },
    {
        icon: faBoxOpen,
        titulo: 'Registra tus productos',
        texto: 'Agregá tus productos, precios, imágenes y categorías para que aparezcan en tu tienda.',
    },
    {
        icon: faShareNodes,
        titulo: 'Comparte tu enlace',
        texto: 'Difundí el enlace de tu tienda y empezá a recibir pedidos.',
    },
];

export default function NuevoClienteModal() {
    const { productos, loading } = useData();
    const navigate = useNavigate();
    const [cerrado, setCerrado] = useState(false);

    const slug = getTenantSlug();
    const hayAdmin = !!storage.getItem('adminUser');

    const mostrar = !cerrado && !loading && slug && productos?.length === 0 && !hayAdmin;

    if (!mostrar) return null;

    const irAlPanel = () => {
        navigate(ruta('/dashboard'));
    };

    const cerrar = () => {
        setCerrado(true);
    };

    return (
        <div className="nuevoClienteOverlay">
            <div className="nuevoClienteModal">
                <div className="nuevoClienteIcono">
                    <FontAwesomeIcon icon={faRocket} />
                </div>

                <h2>¡Bienvenido a tu tienda en línea!</h2>
                <p className="nuevoClienteSub">
                    Tu catálogo todavía no tiene productos. Para empezar a vender, primero
                    iniciá sesión en tu panel de administración y registrá tus productos.
                </p>

                <div className="nuevoClientePasos">
                    {pasos.map((paso, index) => (
                        <div className="nuevoClientePaso" key={index}>
                            <div className="nuevoClientePasoIcono">
                                <FontAwesomeIcon icon={paso.icon} />
                            </div>
                            <div className="nuevoClientePasoText">
                                <strong>{index + 1}. {paso.titulo}</strong>
                                <span>{paso.texto}</span>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="nuevoClienteBtns">
                    <button className="btnPrimario" onClick={irAlPanel}>
                        Ir a mi panel de administración
                    </button>
                    <button className="btnSecundario" onClick={cerrar}>
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
}